import { render, staticRenderFns } from "./CanSeePrices.vue?vue&type=template&id=056ac3f7&"
import script from "./CanSeePrices.vue?vue&type=script&lang=js&"
export * from "./CanSeePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports